import React from "react";
import NavMenu from "../Nav/NavMenu";
import Footer from "../footer/Footer";
import EmptySlider from "../sliders/EmptySlider";
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from "react-bootstrap";
import businessSupportImage from "../../assets/static/business/business_banking.png";

function BusinessSupport() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br>
      <br></br>
      <EmptySlider
        title="Business Support? We’ve got you covered."
        description="Kontriman offers various ways to support your Business Deposit Account – through our help center, chat support, and email. Get the assistance you need, anytime and anywhere."
        imageUrl={FlightImage}
      />

      <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Image column */}
              <Col md={6} className="order-1 order-md-1">
                <img
                  src={businessSupportImage}
                  alt="Business Support"
                  className="img-fluid"
                />
              </Col>

              {/* Text column */}
              <Col
                md={6}
                className="d-flex align-items-center order-2 order-md-2"
              >
                <div>
                  <h1 className="custom_heading">Business Support Services</h1>
                  <p>
                    At Kontriman, we understand the challenges businesses face.
                    That’s why we provide end-to-end support solutions tailored
                    for entrepreneurs, SMEs, and corporate clients.
                  </p>

                  <h5 className="mt-4">What We Offer</h5>
                  <ul>
                    <li>Financial advisory and planning</li>
                    <li>Dedicated business relationship managers</li>
                    <li>Workshops, training, and mentoring programs</li>
                    <li>24/7 customer and technical support</li>
                    <li>Market research and strategy insights</li>
                  </ul>

                  <h5 className="mt-4">Who Can Benefit?</h5>
                  <ul>
                    <li>Startups looking for a strong financial foundation</li>
                    <li>
                      Established businesses aiming for growth and expansion
                    </li>
                    <li>Organizations needing expert business advisory</li>
                  </ul>

                  <a href="mailto:info@kontriman.com">
                    <Button className="custom-button mt-3">
                      Get Business Support
                    </Button>
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </Container>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default BusinessSupport;

